export default __webpack_public_path__ + "static/media/orange-gradient-box.da9c67a0.svg";